export const MAINTENANCE_ENABLED = window.MAINTENANCE === 'true';
export const ACCESSIBILITY_EMAIL = window.ACCESSIBILITY_EMAIL;
